import React from 'react';
import { Image as ImageType } from '../../commonTypes/image';
import componentProps, { ComponentProps } from '../../helpers/componentProps';
import { applyComponentTheme } from '../../theme';
import { GridItem } from '../Grid';
import Image from '../Image';
import { GridWithMargins } from './styles';

type ImageBreakProps = {
  image: ImageType;
} & ComponentProps;

const ImageBreak: React.FC<ImageBreakProps> = ({ image, ...props }) => (
  <GridWithMargins {...componentProps(props)}>
    <GridItem desktop={4} tabletLandscape={4} tabletPortrait={4}>
      <Image image={image} />
    </GridItem>
  </GridWithMargins>
);

export default applyComponentTheme(ImageBreak, 'imageBreak');
